export const defaultColumns = [
  { label: 'Nome', value: 'display_name' },
  { label: 'Validade padrão', value: 'default_validity_in_days', className: 'w-9' },
  { label: 'Ação', value: 'action', className: 'w-9' },
]
